<script setup lang="ts">
/**
 * Barre d'onglets mobile : pilule flottante au-dessus du bas d'écran, délimitée par un filet
 * (aucune ombre). 4 destinations et l'action principale « Ajouter » au centre, sous le pouce.
 */
import { RouterLink, type RouteLocationRaw } from 'vue-router'

import { fr } from '@/copy/fr'

import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

export interface TabItem {
  to: RouteLocationRaw
  label: string
  icon: IconName
}

defineProps<{ items: readonly [TabItem, TabItem, TabItem, TabItem]; addLabel: string }>()
defineEmits<{ add: [] }>()

const LINK =
  'flex h-full flex-1 flex-col items-center justify-center gap-0.5 text-caption text-ink-muted transition-colors duration-80'
const ACTIVE = 'text-accent-strong!'
</script>

<template>
  <nav class="fixed inset-x-0 bottom-safe-3 z-30 px-3" :aria-label="fr.ui.mainNavigation">
    <div
      class="mx-auto flex h-16 max-w-md items-stretch rounded-full border border-line bg-bg px-2"
    >
      <RouterLink :to="items[0].to" :class="LINK" :active-class="ACTIVE">
        <Icon :name="items[0].icon" :size="24" />
        <span>{{ items[0].label }}</span>
      </RouterLink>
      <RouterLink :to="items[1].to" :class="LINK" :active-class="ACTIVE">
        <Icon :name="items[1].icon" :size="24" />
        <span>{{ items[1].label }}</span>
      </RouterLink>
      <div class="flex flex-1 items-center justify-center">
        <button
          type="button"
          class="flex size-12 items-center justify-center rounded-full bg-accent-strong text-ink-inverse transition-colors duration-80 active:bg-accent-pressed"
          :aria-label="addLabel"
          @click="$emit('add')"
        >
          <Icon name="add" :size="24" />
        </button>
      </div>
      <RouterLink :to="items[2].to" :class="LINK" :active-class="ACTIVE">
        <Icon :name="items[2].icon" :size="24" />
        <span>{{ items[2].label }}</span>
      </RouterLink>
      <RouterLink :to="items[3].to" :class="LINK" :active-class="ACTIVE">
        <Icon :name="items[3].icon" :size="24" />
        <span>{{ items[3].label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>
